module.exports = __webpack_public_path__ + "img/ku5_act.de8e8cc0.png";